module.exports = __webpack_public_path__ + "img/PCMessageddmessage.aed8de06.png";